import { SearchFilters, Sort } from "../models/search";
import dayjs from "dayjs";
import { formatToYYYYMMDD } from "../utils/utils";

export const DEFAULT_START_DATE = dayjs().subtract(1, "year").startOf("month");
export const DEFAULT_END_DATE = dayjs().endOf("day"); // must be end of day to prevent errors on selecting "today"

export const defaultFilterState: SearchFilters = {
  base_filters: {},
  visual_filters: {
    topics_sentiment: {},
    keywords: [],
    inquiry_source_breakdown: [],
  },
  query: null,
  dates: {
    start: formatToYYYYMMDD(DEFAULT_START_DATE),
    end: formatToYYYYMMDD(DEFAULT_END_DATE),
  },
  dynamic_date_range: null,
  semantic: true,
  join_ids: [],
  stack_related: true,
};

// Even though sort goes into the filter object that is sent to
// the API, it is separated out so that changing the sort of the verbatims
// does not require re-rendering the entire page.
export const defaultSort: Sort | null = null;
